export { analytics } from "./analytics"

export const isEnterOrSpaceKeyPress = event => {
  const { type, keyCode, code } = event || {}

  return (
    type === "keydown" &&
    // Support depricated keyCode for IE11 and Edge
    [13, 32].indexOf(code || keyCode) !== -1
  )
}

export const isEnterKeyPress = event => {
  const { type, keyCode, code } = event || {}

  return (
    type === "keydown" &&
    // Support depricated keyCode for IE11 and Edge
    (code || keyCode === 13)
  )
}

export const getEventValue = event => {
  const { target } = event || {}
  const { value } = target || {}
  return value
}

/**
 * Generate IDs for group section and its fields. Used for mapping errors to fields
 */
export const getGroupIds = id => ({
  id,
  groupTypeId: `${id}-group-type`,
  personsId: `${id}-persons`,
  daysId: `${id}-days`
})

/**
 * Check whether given group exists in given groups set
 */
export const containsGroup = (groups, group) => (groups || []).filter(g => g.groupType === group.groupType).length !== 0

export const buildElementId = (componentId, elementId) => {
  return componentId + "_" + elementId
}
